import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { filterTableDataAPI } from "services/CRUDServices"

export const filterDriverPayrollBaseInfo: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "driver-payroll-base-info",
  async (body: any) => {
    const data = await filterTableDataAPI(
      "/consignment-api/distributionPayementRuleApi/v1/s0/grid",
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    )

    return data.data.response
  }
)

const initialState: any = {
  driverPayrollData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
}

const DriverPayrollSlice = createSlice({
  initialState: initialState,
  name: "contractor",
  reducers: {
    clearDriverPayrollBaseInfo: (state) => {
      state.driverPayrollData = []
    },
    setDriverPayrollBaseInfoFilter: (state, action) => {
      state.filter = action.payload
    },
    changeDriverSwitch: (state: any, { payload }) => {
         const filterSwitch = state.driverPayrollData?.content?.find(
           (item: any) => item?.id === payload
         );
         if (filterSwitch) {
           filterSwitch.isActive = !filterSwitch.isActive;
         }
       },
  },
  extraReducers: {
    [filterDriverPayrollBaseInfo.fulfilled as any]: (state, action) => {
      state.driverPayrollData = action.payload
      state.fetchpost = false
    },
    [filterDriverPayrollBaseInfo.pending as any]: (state) => {
      state.fetchpost = true
    },
    [filterDriverPayrollBaseInfo.rejected as any]: (state) => {
      state.fetchpost = false
      state.errorMessage = "wrong"
    },
  },
})

export const { setDriverPayrollBaseInfoFilter, clearDriverPayrollBaseInfo,changeDriverSwitch } =
  DriverPayrollSlice.actions
export default DriverPayrollSlice.reducer
